import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { trIco } from 'constants/generic';

interface ProposalHtmlTripadvisorProps {
  tripAdvisorHotel: any;
  hideWrapper?: boolean;
}

const ProposalHtmlTripadvisor: FC<ProposalHtmlTripadvisorProps> = ({ tripAdvisorHotel, hideWrapper }) => {
  const { t } = useTranslation();
  if (!tripAdvisorHotel) return null;

  return (
    <div className="pr-hotel-div pr-ta" style={{ borderTop: hideWrapper ? 'none' : '1px solid #ddd' }}>
      <div className="pr-ta-title"><img src={trIco} alt="" style={{ margin: '0 5px', width: 20, height: 20 }} /> Tripadvisor</div>
      <div className="pr-ta-hotel-link">
        <a
          href={tripAdvisorHotel.webUrl}
          target="_blank"
          rel="noreferrer"
          className="pr-ta-hotel-anchor"
        >
          {tripAdvisorHotel.name}
        </a>
      </div>
      <div>
        {!!tripAdvisorHotel.rankingData?.rankingString && !!tripAdvisorHotel.description && (
          <>
            <div className="pr-ta-ranking">{tripAdvisorHotel.rankingData?.rankingString}</div>
            {tripAdvisorHotel.description && (
              <div className="pr-ta-desc">{tripAdvisorHotel.description}</div>
            )}
          </>
        )}
        {!!tripAdvisorHotel?.numReviews && !!tripAdvisorHotel?.reviewRatingCount && (
          <>
            <div className="pr-ta-review-header">
              <img
                src={tripAdvisorHotel.ratingImageUrl}
                alt="rating"
                className="pr-ta-rating-img"
              />
              <span>
                {tripAdvisorHotel.numReviews} {t('proposal.reviews')}
              </span>
              <span className="pr-ta-review-sep">|</span>
              <span>{tripAdvisorHotel.rankingData?.rankingString}</span>
            </div>
            <div className="pr-ta-review-label">{t('proposal.reviews')}:</div>
            <div>
              <label className="pr-ta-checkbox-label">
                Excelent: {tripAdvisorHotel.reviewRatingCount._5 || '0'}
              </label>
              <label className="pr-ta-checkbox-label">
                Very Good: {tripAdvisorHotel.reviewRatingCount._4 || '0'}
              </label>
              <label className="pr-ta-checkbox-label">
                Everage: {tripAdvisorHotel.reviewRatingCount._3 || '0'}
              </label>
              <label className="pr-ta-checkbox-label">
                Poor: {tripAdvisorHotel.reviewRatingCount._2 || '0'}
              </label>
              <label className="pr-ta-checkbox-label">
                Terrible: {tripAdvisorHotel.reviewRatingCount._1 || '0'}
              </label>
            </div>
            {tripAdvisorHotel.subratings && (
              <div className="pr-ta-subratings">
                {Object.entries(tripAdvisorHotel.subratings).map(([k, r]: [string, any], index) => (
                  <div key={index} className="pr-ta-subrating-row">
                    {!!r?.localized_name && (
                      <span className="pr-ta-subrating-label">{r.localized_name}</span>
                    )}
                    <img src={r.rating_image_url} alt="subrating" className="pr-ta-subrating-img" />
                    <span className="pr-ta-subrating-value">{r.objvalue}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
        {tripAdvisorHotel.amenities && tripAdvisorHotel.amenities.length > 0 && (
          <Fragment>
            <div className="pr-ta-amenities-label">{t('proposal.amenities')}:</div>
            <ul className="pr-ta-amenities-list">
              {tripAdvisorHotel.amenities.map((amen: any, index: number) => (
                <li className="pr-ta-amenity" key={index}>
                  {amen}
                </li>
              ))}
            </ul>
            <div className="pr-ta-amenities-bottom"></div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default ProposalHtmlTripadvisor;
